import http from 'plugins/axios';

export default {
  getAuditList(query) {
    return http.get({
      url: '/admin/tribe/list',
      data: {
        ...query
      }
    });
  },
  approveAudit({ id }) {
    return http.post({
      url: '/admin/tribe/updateTribe',
      data: {
        editId: id
      },
      dataType: 'form'
    });
  }
};
